import queryString from "query-string"
import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"

import { queryStringify } from "common/helpers/admin-page-func.helper"

export function useAdminFilter(
    config = {
        execFilterAfterMs: 0
    }
) {
    const history = useHistory()
    const location = useLocation()

    const [filter, setFilter] = useState({})
    const [typingTimeout, setTypingTimeout] = useState(null)

    useEffect(() => {
        setFilter(queryString.parse(location.search))
    }, [location.search])

    const onChange = key => event => {
        const value = String(event.target.value)
        const newFilter = { ...filter, [key]: value }
        const updateUrlFunc = updateUrl(newFilter)

        if (typingTimeout !== null) {
            window.clearTimeout(typingTimeout)
        }

        if (!value.length || event.currentTarget.tagName !== "INPUT") {
            // avoid delay when clearing out target or
            // target is not an input element (ex. select/dropdown)
            updateUrlFunc()
            return
        }

        setTypingTimeout(window.setTimeout(updateUrlFunc, config.execFilterAfterMs))
        setFilter(newFilter)
    }

    const updateUrl = newFilter => () => {
        const search = queryStringify(newFilter)
        history.push({ search })
    }

    return [filter, onChange]
}
